import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  drawerDesktopRoot: {
    top: '4rem !important',
  },
  drawerDesktop: {
    top: '4rem',
    height: 'calc(100vh - 4rem)',
    width: '100vw',
    background: '#FDFDFD',
    overflow: 'hidden',
    transition: 'transform 350ms cubic-bezier(0, 0, 0.2, 1) 0ms',
  },
  drawerMobile: {
    height: '100vh',
    width: '100vw',
    background: '#FDFDFD',
    overflow: 'hidden',
    transition: 'transform 350ms cubic-bezier(0, 0, 0.2, 1) 0ms',
  },
  backdrop: {
    display: 'none',
  },
}));
